import React from "react";
import { Link } from "react-router-dom";

// Internal route → <Link>; external URL → new tab, no opener.
const LegalLink = ({ link, className, onClick, children }) =>
  link.external ? (
    <a
      className={className}
      href={link.href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      {children || link.label}
    </a>
  ) : (
    <Link className={className} to={link.href} onClick={onClick}>
      {children || link.label}
    </Link>
  );

export default LegalLink;
